import { createContext } from 'use-context-selector';
import { ParametersState } from './types';
import { defaultParametersState } from './defaultState';

const ParametersContext = createContext<Partial<ParametersState>>(defaultParametersState);

export { ParametersContext };
